import { __ } from "@wordpress/i18n"
import { 
  useBlockProps, 
  InspectorControls
} from "@wordpress/block-editor"
import { 
  PanelBody,
  Notice
} from "@wordpress/components"

export default function Edit({ attributes, setAttributes }) {
  const blockProps = useBlockProps({
    className: "emergency-banner emergency-banner-partnerships"
  })

  // Get site globals (available via wp_localize_script)
  const siteGlobals = window.siteGlobals || {}

  // Partnerships page always shows corporate office
  const displayData = {
    locationName: 'PuroClean HQ',
    phoneNumber: siteGlobals.phone || '(800) 775-7876',
    localWebsiteUrl: siteGlobals.website || '#',
    localWebsiteText: 'Visit Local Website'
  }

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Emergency Banner - Partnerships (Site Globals)', 'puroclean')} initialOpen={true}>
          <Notice status="info" isDismissible={false}>
            <p>
              <strong>Partnerships Page Banner</strong><br />
              This block is specifically for the partnerships page.<br />
              <br />
              <strong>Features:</strong><br />
              • Always shows corporate office (PuroClean HQ)<br />
              • Phone number button replaces AI assistant<br />
              • No change location link<br />
              <br />
              <strong>Current Values:</strong><br />
              Location: {displayData.locationName}<br />
              Phone: {displayData.phoneNumber}<br />
              Website: {displayData.localWebsiteUrl}
            </p>
          </Notice>
          
          <Notice status="warning" isDismissible={false}>
            <p>
              To modify phone number, update your Site Globals settings.<br />
              Location is always set to corporate office for partnerships page.
            </p>
          </Notice>
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        {/* Emergency Banner Section (Desktop Only) */}
        <div className="bg-primary-700 text-white w-full py-6">
          <div className="container max-w-content mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
              
              {/* Left Column - Location Info (Corporate Only) */}
              <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
                <p className="~text-16/xl font-semibold mb-2">
                  {displayData.locationName}
                </p>
                {/* No change location link for partnerships */}
              </div>
              
              {/* Right Column - Phone Number Button */}
              <div className="flex items-center">
                <div className="ragbot-input rb-border" style={{
                  padding: '12px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '200px',
                  height: '46px',
                  margin: 0,
                  zIndex: 3,
                  textDecoration: 'none'
                }}>
                  <span style={{ fontSize: '14px', fontWeight: 600, color: '#103569' }}>
                    {displayData.phoneNumber}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

